import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IdexService} from '../../idex.service';

@Component({
   selector: 'app-authen-sign',
   templateUrl: './authen-sign.component.html',
   styleUrls: ['./authen-sign.component.css']
})
export class AuthenSignComponent {
   errorMessage: string;
   taskid: any;

   constructor(private router: Router, private route: ActivatedRoute, private service: IdexService) {
   }

}
